module.exports = __webpack_public_path__ + "0b70f42e2fb44c433663b119a44909ff.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/burger-hat.jpg
 ** module id = 450
 ** module chunks = 0
 **/